import aiMlImg from '../img/servizi/ai-ml.png';
import webDevImg from '../img/servizi/web-dev.png';
import consultingImg from '../img/servizi/consulting.png';
import dataEngImg from '../img/servizi/data-eng.png';
import cybersecImg from '../img/servizi/cybersec.png';
import cloudAutoImg from '../img/servizi/cloud-auto.png';

const serviziData = [
	{
		id: 'ai-ml',
		slug: 'intelligenza-artificiale',
		title: 'Intelligenza Artificiale & Machine Learning',
		subtitle: 'Trasformiamo i dati in valore con soluzioni AI su misura',
		metaDescription: 'Servizi di Intelligenza Artificiale e Machine Learning a Roma: chatbot AI, analisi predittiva, computer vision, integrazione LLM (GPT, Claude). Studio Ing. Bernasconi.',
		metaKeywords: 'intelligenza artificiale Roma, machine learning, chatbot AI, LLM, GPT, Claude, computer vision, analisi predittiva, NLP, automazione AI',
		icon: 'carbon:machine-learning-model',
		gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
		accentColor: '#764ba2',
		heroImage: aiMlImg,
		bannerIcons: ['carbon:machine-learning-model', 'carbon:chat-bot', 'carbon:analytics', 'carbon:api', 'carbon:model-alt'],
		shortDescription:
			'Automatizza decisioni, riduci i costi e anticipa i trend. Chatbot, analisi predittiva e integrazione di AI generativa (GPT, Claude) nel tuo business.',
		longDescription:
			"L'Intelligenza Artificiale sta ridefinendo ogni settore industriale. Il nostro studio progetta e implementa soluzioni AI personalizzate che risolvono problemi reali: dall'automazione dei processi decisionali all'analisi di grandi volumi di dati, dall'interazione naturale uomo-macchina alla visione artificiale. Integriamo i modelli linguistici di ultima generazione (LLM) come GPT e Claude nelle infrastrutture aziendali, creando assistenti virtuali, sistemi di analisi documentale e strumenti di supporto decisionale.",
		features: [
			{
				icon: 'carbon:chat-bot',
				title: 'Chatbot & Assistenti Virtuali',
				description:
					'Assistenti AI conversazionali basati su LLM per customer service, supporto interno e automazione.',
			},
			{
				icon: 'carbon:image-search',
				title: 'Computer Vision',
				description:
					'Sistemi di riconoscimento immagini, analisi video e controllo qualità automatizzato.',
			},
			{
				icon: 'carbon:analytics',
				title: 'Analisi Predittiva',
				description:
					'Modelli di machine learning per previsioni, trend analysis e ottimizzazione dei processi.',
			},
			{
				icon: 'carbon:api',
				title: 'Integrazione LLM',
				description:
					'Integrazione di GPT, Claude e modelli open-source nelle infrastrutture aziendali esistenti.',
			},
			{
				icon: 'carbon:text-link-analysis',
				title: 'Natural Language Processing',
				description:
					'Analisi del linguaggio naturale, classificazione documenti ed estrazione di informazioni.',
			},
			{
				icon: 'carbon:workflow-automation',
				title: 'Automazione AI-Powered',
				description:
					'Workflow intelligenti che apprendono e si adattano per ottimizzare i processi aziendali.',
			},
		],
		useCases: [
			'Chatbot per assistenza clienti 24/7 con comprensione del linguaggio naturale',
			'Sistema di analisi predittiva per la manutenzione industriale',
			'Piattaforma di classificazione automatica documenti per studi legali',
			'Assistente virtuale interno per knowledge management aziendale',
		],
		technologies: [
			'Python',
			'TensorFlow',
			'PyTorch',
			'OpenAI API',
			'Claude API',
			'LangChain',
			'Hugging Face',
			'scikit-learn',
		],
	},
	{
		id: 'web-dev',
		slug: 'sviluppo-web',
		title: 'Sviluppo Web & Applicazioni',
		subtitle: 'Applicazioni web moderne, performanti e scalabili',
		metaDescription: 'Sviluppo Web e Applicazioni a Roma: React, Next.js, Node.js, PWA, piattaforme SaaS, e-commerce, API REST e microservizi. Studio Ing. Bernasconi.',
		metaKeywords: 'sviluppo web Roma, applicazioni web, React, Next.js, Node.js, PWA, SaaS, e-commerce, API REST, microservizi',
		icon: 'carbon:application-web',
		gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
		accentColor: '#f5576c',
		heroImage: webDevImg,
		bannerIcons: ['carbon:application-web', 'carbon:code', 'carbon:mobile-download', 'carbon:api-1', 'carbon:shopping-cart'],
		shortDescription:
			'Il tuo software deve lavorare per te, non contro di te. App web veloci, e-commerce, gestionali SaaS e piattaforme su misura che i clienti amano usare.',
		longDescription:
			"Progettiamo e sviluppiamo applicazioni web complete, dalla user experience al backend. Utilizziamo le tecnologie più moderne per garantire performance, sicurezza e scalabilità. Che si tratti di una Progressive Web App, una piattaforma SaaS multi-tenant o un e-commerce ad alte prestazioni, il nostro approccio è sempre orientato alla qualità del codice e all'esperienza utente.",
		features: [
			{
				icon: 'carbon:application',
				title: 'Web Application su misura',
				description:
					'Applicazioni web custom progettate sulle esigenze specifiche del cliente.',
			},
			{
				icon: 'carbon:mobile-download',
				title: 'Progressive Web App (PWA)',
				description:
					'App che funzionano offline, si installano come native e offrono performance eccellenti.',
			},
			{
				icon: 'carbon:cloud-service-management',
				title: 'Piattaforme SaaS',
				description:
					'Soluzioni Software-as-a-Service multi-tenant con abbonamento e gestione utenti.',
			},
			{
				icon: 'carbon:api-1',
				title: 'API REST & Microservizi',
				description:
					'Architetture backend scalabili con API documentate e microservizi indipendenti.',
			},
			{
				icon: 'carbon:shopping-cart',
				title: 'E-commerce',
				description:
					'Piattaforme di vendita online con pagamenti, gestione inventario e logistica.',
			},
			{
				icon: 'carbon:code',
				title: 'Frontend React / Backend Node.js',
				description:
					'Stack tecnologico moderno con React, Next.js, Node.js, Express e database SQL/NoSQL.',
			},
		],
		useCases: [
			'Piattaforma gestionale web per PMI con dashboard personalizzabili',
			'E-commerce B2B con catalogo prodotti e ordini automatizzati',
			'Portale documentale con ricerca full-text e gestione permessi',
			'PWA per raccolta dati sul campo con funzionalità offline',
		],
		technologies: [
			'React',
			'Next.js',
			'Node.js',
			'Express',
			'PostgreSQL',
			'MongoDB',
			'TypeScript',
			'Docker',
		],
	},
	{
		id: 'consulting',
		slug: 'trasformazione-digitale',
		title: 'Consulenza IT & Trasformazione Digitale',
		subtitle: "Accompagniamo la tua azienda nell'innovazione digitale",
		metaDescription: 'Consulenza IT e Trasformazione Digitale a Roma: strategia digitale, ottimizzazione processi, migrazione legacy, project management Agile. Studio Ing. Bernasconi.',
		metaKeywords: 'consulenza IT Roma, trasformazione digitale, strategia digitale, migrazione legacy, project management, Agile, TOGAF, innovazione digitale',
		icon: 'carbon:strategy-play',
		gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
		accentColor: '#4facfe',
		heroImage: consultingImg,
		bannerIcons: ['carbon:strategy-play', 'carbon:flow', 'carbon:idea', 'carbon:task', 'carbon:education'],
		shortDescription:
			"Non sai da dove iniziare? Ti guidiamo passo passo: dall'analisi dei processi alla strategia IT, dalla migrazione dei sistemi vecchi all'innovazione che conta.",
		longDescription:
			"La trasformazione digitale non è solo tecnologia: è un cambio di paradigma che coinvolge processi, persone e cultura aziendale. Il nostro studio offre consulenza strategica per guidare organizzazioni di ogni dimensione nel percorso di digitalizzazione. Analizziamo i processi esistenti, identifichiamo le opportunità di miglioramento e progettiamo roadmap di trasformazione concrete e sostenibili. Supportiamo la Pubblica Amministrazione e le imprese private nell'adozione di soluzioni digitali innovative.",
		features: [
			{
				icon: 'carbon:roadmap',
				title: 'Strategia Digitale',
				description:
					'Definizione della roadmap digitale allineata agli obiettivi di business.',
			},
			{
				icon: 'carbon:flow',
				title: 'Analisi e Ottimizzazione Processi',
				description:
					'Mappatura dei processi AS-IS e progettazione dei flussi TO-BE ottimizzati.',
			},
			{
				icon: 'carbon:migrate',
				title: 'Migrazione Sistemi Legacy',
				description:
					'Modernizzazione graduale dei sistemi obsoleti verso architetture cloud-native.',
			},
			{
				icon: 'carbon:task',
				title: 'Project Management IT',
				description:
					'Gestione progetti tecnologici con metodologie Agile e framework strutturati.',
			},
			{
				icon: 'carbon:idea',
				title: 'Digital Innovation',
				description:
					'Scouting tecnologico e prototipazione rapida per validare nuove soluzioni.',
			},
			{
				icon: 'carbon:education',
				title: 'Formazione Tecnologica',
				description:
					'Programmi di formazione per team IT e utenti finali sulle nuove tecnologie.',
			},
		],
		useCases: [
			'Piano di trasformazione digitale triennale per ente pubblico',
			'Migrazione da sistema gestionale monolitico a microservizi cloud',
			"Assessment tecnologico e roadmap di innovazione per PMI manifatturiera",
			'Formazione aziendale su strumenti AI e automazione dei processi',
		],
		technologies: [
			'Agile/Scrum',
			'BPMN',
			'Enterprise Architecture',
			'TOGAF',
			'Design Thinking',
			'Lean IT',
		],
	},
	{
		id: 'data-eng',
		slug: 'data-engineering',
		title: 'Data Engineering & Business Intelligence',
		subtitle: 'Dai dati grezzi agli insight strategici',
		metaDescription: 'Data Engineering e Business Intelligence a Roma: pipeline dati, dashboard analitiche, data warehouse, ETL, Power BI, BigQuery. Studio Ing. Bernasconi.',
		metaKeywords: 'data engineering Roma, business intelligence, dashboard analitiche, data warehouse, ETL, Power BI, BigQuery, Snowflake, Apache Airflow',
		icon: 'carbon:chart-multitype',
		gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
		accentColor: '#38d9a9',
		heroImage: dataEngImg,
		bannerIcons: ['carbon:chart-multitype', 'carbon:dashboard', 'carbon:data-connected', 'carbon:report', 'carbon:data-base'],
		shortDescription:
			'Smetti di decidere a intuito. Dashboard in tempo reale, report automatizzati e pipeline dati che trasformano numeri grezzi in strategie vincenti.',
		longDescription:
			"I dati sono il nuovo petrolio, ma solo se estratti, raffinati e utilizzati correttamente. Il nostro studio progetta architetture dati end-to-end: dalla raccolta e integrazione delle fonti, alla trasformazione e pulizia, fino alla visualizzazione e all'analisi avanzata. Costruiamo data warehouse moderni, pipeline ETL/ELT robuste e dashboard interattive che trasformano i dati in decisioni strategiche.",
		features: [
			{
				icon: 'carbon:data-connected',
				title: 'Data Pipeline & ETL',
				description:
					'Pipeline dati automatizzate per raccolta, trasformazione e caricamento da fonti eterogenee.',
			},
			{
				icon: 'carbon:dashboard',
				title: 'Dashboard Analitiche',
				description:
					'Dashboard interattive e report personalizzati per monitoraggio KPI in tempo reale.',
			},
			{
				icon: 'carbon:data-base',
				title: 'Data Warehouse',
				description:
					'Progettazione e implementazione di data warehouse cloud per analisi storiche e trend.',
			},
			{
				icon: 'carbon:report',
				title: 'Reportistica Avanzata',
				description:
					'Report automatizzati con distribuzione schedulata e alert su soglie critiche.',
			},
			{
				icon: 'carbon:policy',
				title: 'Data Governance',
				description:
					'Framework di governance dati per qualità, lineage e conformità normativa.',
			},
			{
				icon: 'carbon:data-enrichment',
				title: 'Integrazione Dati Multi-sorgente',
				description:
					'Connessione e armonizzazione di dati provenienti da sistemi, API e fonti esterne.',
			},
		],
		useCases: [
			'Data warehouse per catena retail con analisi vendite multi-punto vendita',
			'Dashboard real-time per monitoraggio KPI di produzione industriale',
			'Pipeline dati per aggregazione e analisi dati IoT da sensori sul campo',
			'Sistema di reportistica automatizzata per compliance bancaria',
		],
		technologies: [
			'Apache Airflow',
			'dbt',
			'BigQuery',
			'Snowflake',
			'Power BI',
			'Grafana',
			'Apache Kafka',
			'Python/Pandas',
		],
	},
	{
		id: 'cybersec',
		slug: 'cybersecurity',
		title: 'Cybersecurity & Protezione Dati',
		subtitle: "Proteggiamo la tua infrastruttura nell'era digitale",
		metaDescription: 'Cybersecurity e Protezione Dati a Roma: audit sicurezza, conformità GDPR, vulnerability assessment, incident response, IAM. Studio Ing. Bernasconi.',
		metaKeywords: 'cybersecurity Roma, protezione dati, GDPR, audit sicurezza, vulnerability assessment, ISO 27001, NIST, Zero Trust, incident response',
		icon: 'carbon:security',
		gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
		accentColor: '#fa709a',
		heroImage: cybersecImg,
		bannerIcons: ['carbon:security', 'carbon:fingerprint-recognition', 'carbon:scan-alt', 'carbon:document-security', 'carbon:warning-alt'],
		shortDescription:
			"Un attacco informatico pu\u00f2 bloccare la tua azienda per giorni. Audit di sicurezza, conformit\u00e0 GDPR e protezione proattiva prima che sia troppo tardi.",
		longDescription:
			"In un mondo sempre più connesso, la sicurezza informatica non è un optional ma una necessità strategica. Il nostro studio offre servizi completi di cybersecurity: dall'audit delle infrastrutture esistenti alla progettazione di architetture sicure, dalla conformità normativa (GDPR, NIS2) alla formazione del personale. Adottiamo un approccio proattivo alla sicurezza, identificando le vulnerabilità prima che possano essere sfruttate.",
		features: [
			{
				icon: 'carbon:security-services',
				title: 'Audit di Sicurezza',
				description:
					'Valutazione completa della postura di sicurezza con report dettagliato e piano di remediation.',
			},
			{
				icon: 'carbon:document-security',
				title: 'Conformità GDPR & Privacy',
				description:
					'Consulenza per adeguamento GDPR, DPIA, registro trattamenti e DPO as-a-service.',
			},
			{
				icon: 'carbon:scan-alt',
				title: 'Vulnerability Assessment',
				description:
					'Scansione sistematica delle vulnerabilità con prioritizzazione basata sul rischio.',
			},
			{
				icon: 'carbon:warning-alt',
				title: 'Incident Response',
				description:
					'Piani di risposta agli incidenti, gestione delle crisi e analisi forense digitale.',
			},
			{
				icon: 'carbon:user-certification',
				title: 'Security Awareness Training',
				description:
					'Programmi di formazione per sensibilizzare il personale sulle minacce cyber.',
			},
			{
				icon: 'carbon:fingerprint-recognition',
				title: 'Identity & Access Management',
				description:
					'Progettazione di sistemi IAM con autenticazione multi-fattore e single sign-on.',
			},
		],
		useCases: [
			"Audit di sicurezza completo per studio professionale con piano di remediation",
			'Adeguamento GDPR per azienda sanitaria con gestione dati sensibili',
			'Implementazione sistema IAM con MFA per organizzazione con 500+ utenti',
			'Programma di security awareness con simulazioni di phishing per PMI',
		],
		technologies: [
			'OWASP',
			'ISO 27001',
			'NIST Framework',
			'SIEM',
			'WAF',
			'Zero Trust Architecture',
		],
	},
	{
		id: 'cloud-auto',
		slug: 'cloud-automazione',
		title: 'Cloud, Automazione & Integrazione',
		subtitle: 'Infrastruttura moderna, processi automatizzati',
		metaDescription: 'Cloud Computing, Automazione e Integrazione Sistemi a Roma: migrazione cloud AWS/Azure/GCP, DevOps, CI/CD, RPA, Kubernetes. Studio Ing. Bernasconi.',
		metaKeywords: 'cloud computing Roma, migrazione cloud, AWS, Azure, GCP, DevOps, CI/CD, Kubernetes, Docker, Terraform, RPA, automazione',
		icon: 'carbon:cloud-services',
		gradient: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
		accentColor: '#a18cd1',
		heroImage: cloudAutoImg,
		bannerIcons: ['carbon:cloud-services', 'carbon:continuous-deployment', 'carbon:bot', 'carbon:connect', 'carbon:virtual-machine'],
		shortDescription:
			"Elimina i colli di bottiglia. Cloud migration, automazione dei processi ripetitivi e integrazione dei sistemi per risparmiare tempo e ridurre i costi.",
		longDescription:
			"Il cloud computing e l'automazione sono i pilastri dell'infrastruttura IT moderna. Il nostro studio progetta migrazioni cloud sicure e graduali, implementa pipeline DevOps per deployment continuo, automatizza i processi ripetitivi con soluzioni RPA e integra sistemi eterogenei in un ecosistema coerente. L'obiettivo è un'infrastruttura scalabile, resiliente e cost-effective.",
		features: [
			{
				icon: 'carbon:cloud-upload',
				title: 'Cloud Migration',
				description:
					'Migrazione pianificata verso AWS, Azure o GCP con minimo downtime e massima sicurezza.',
			},
			{
				icon: 'carbon:continuous-deployment',
				title: 'DevOps & CI/CD',
				description:
					'Pipeline di integrazione e deployment continuo per rilasci rapidi e affidabili.',
			},
			{
				icon: 'carbon:bot',
				title: 'Robotic Process Automation',
				description:
					'Automazione dei processi ripetitivi con bot software per ridurre errori e costi.',
			},
			{
				icon: 'carbon:connect',
				title: 'Integrazione Sistemi',
				description:
					'Connessione di applicazioni, database e servizi tramite API, middleware e message broker.',
			},
			{
				icon: 'carbon:virtual-machine',
				title: 'Infrastructure as Code',
				description:
					'Gestione infrastruttura con Terraform e Ansible per ambienti riproducibili e versionati.',
			},
			{
				icon: 'carbon:activity',
				title: 'Monitoraggio & Performance',
				description:
					'Sistemi di observability con metriche, log e tracing per performance ottimali.',
			},
		],
		useCases: [
			'Migrazione infrastruttura on-premise su AWS con architettura multi-AZ',
			'Pipeline CI/CD per team di sviluppo con deployment automatizzato su Kubernetes',
			'Automazione RPA per processi di fatturazione e riconciliazione contabile',
			'Integrazione ERP-CRM-eCommerce con sincronizzazione dati in tempo reale',
		],
		technologies: [
			'AWS',
			'Azure',
			'GCP',
			'Docker',
			'Kubernetes',
			'Terraform',
			'GitHub Actions',
			'Ansible',
		],
	},
];

export default serviziData;
